import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';

@Component({
  selector: 'app-google-map',
  imports: [
    GoogleMapsModule,
    CommonModule
  ],
  templateUrl: './google-map.component.html',
  styleUrl: './google-map.component.scss'
})
export class GoogleMapComponent {
  @Input({ required: true }) height!: string
  @Output() mapClick = new EventEmitter<any>();  // Output for map click
  @Output() locationChanged = new EventEmitter<google.maps.LatLngLiteral>();
  @Input() location: google.maps.LatLngLiteral | null = null;
  map!: google.maps.Map;

  options: google.maps.MapOptions = {
    mapId: "2d7ab4975e8a46a6",  // Required for AdvancedMarkerElement - replace with your own Map ID from Google Cloud Console
    mapTypeId: 'roadmap'
  };
  center: google.maps.LatLngLiteral = { lat: 11.5618378, lng: 104.8715408 };//11.5618378,104.8715408
  zoom = 16;
  userLocationMarker: google.maps.marker.AdvancedMarkerClickEvent | undefined;

  markers: google.maps.marker.AdvancedMarkerElement[] = [];

  onMapClick(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: { lat: event.latLng.lat(), lng: event.latLng.lng() },
        title: `Marker ${this.markers.length + 1}`
      });

      // Add the marker to the map explicitly
      marker.map = this.map;

      // Store the marker in the array
      // this.markers.push(marker);
      this.markers = [marker]
      this.mapClick.emit(event);
    }
  }

  ngOnInit() {
    this.setCurrentLocation();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['location'] && this.location) {
      this.center = this.location;
      this.markers = [this.createMarker(this.location)]; // Pin marker at the given location
    }
  }

  setCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.locationChanged.emit(this.center);
          this.markers = [this.createMarker(this.center)];
        },
        (error) => {
          console.error('Error getting location:', error);
          // Fallback location if geolocation fails
          this.center = { lat: 11.5618378, lng: 104.8715408 };
          // this.markers = [this.createMarker(this.center)];
        }
      );
    } else {
      console.warn('Geolocation is not supported by this browser.');
      // Fallback location if geolocation is not supported
      this.center = { lat: 11.5618378, lng: 104.8715408 };
      // this.markers = [this.createMarker(this.center)];
    }
  }

  // Function to create AdvancedMarkerElement
  createMarker(position: google.maps.LatLngLiteral): google.maps.marker.AdvancedMarkerElement {
    // Create a DOM node (div) for marker content
    const markerContent = document.createElement('div');
    markerContent.classList.add('marker-content');
    markerContent.innerHTML = 'You are here';

    const marker = new google.maps.marker.AdvancedMarkerElement({
      position: position,
      content: markerContent,  // Use the DOM node as content
    });
    return marker;
  }

}
